<script setup lang="ts">
import {
  watch,
} from 'vue';
import HelpCentersCards from '../../../components/helpCentersCards/HelpCentersCards.vue';
import HelpCentersColumns from './HelpCentersColumns.vue';
import useAdobeExperiment from '../../../common/composables/useAdobeExperiment';
import { useAnalytics } from '../../../common/composables/useAnalytics';
import { useTags } from '../../../common/composables/useTags';

const { adobeExperimentValue } = useAdobeExperiment({ adobeTargetLocation: 'help-center-experience' });

watch(
  () => adobeExperimentValue.value,
  (experimentValue) => {
    if (!experimentValue) return;
    const baseTag = useTags('getTag', 'HELP_CENTER_HOMEPAGE');
    const tag = adobeExperimentValue.value === 'B' ? '_Columns_Variant' : '_Columns_Control';
    useAnalytics('sendViewAnalytics', { pageName: baseTag + tag });
  },
);
</script>

<template>
  <div
    v-if="adobeExperimentValue && adobeExperimentValue === 'B'"
    class="main"
  >
    <HelpCentersCards class="mobile" />
    <HelpCentersColumns class="desktop" />
  </div>
  <HelpCentersCards v-else />
</template>

<style scoped lang="scss">
.main {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 1170px;
}

.mobile {
    display: block;
}

.desktop {
  display: none;
}

@media screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
  .desktop {
    display: block;
  }
}
</style>
